import { motion } from "framer-motion";
import Reveal from "../Reveal";

export default function IntroStatement() {
  return (
    <section className="ad-section bg-white" data-testid="intro-statement">
      <div className="ad-container">
        <div className="max-w-5xl">
          <Reveal>
            <span className="ad-eyebrow">The idea</span>
          </Reveal>
          <h2 className="mt-6 display-lg">
            <Reveal as="span" className="block text-[#111827]">Data is everywhere.</Reveal>
            <Reveal as="span" index={1} className="block text-[#111827]/30">
              Intelligence is what makes it <span className="text-gradient">useful.</span>
            </Reveal>
          </h2>
          <Reveal index={2}>
            <p className="mt-8 max-w-2xl text-lg leading-relaxed text-[#4B5563]">
              We connect data engineering, analytics, AI and cloud technologies to help
              organizations move from fragmented information to confident action.
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
